<template>
  <div class="container">
    <div class="box">
      <div class="box_title">
        <img src="@/assets/images/choydarIcon1.png" alt="" />
        <span>远端血管直径(mm)</span>
      </div>
      
      <div class="inputBox">
        <span class="label"><span class="required">*</span>投射角度1：</span>
        <van-field class="input" v-model="diameter1.angle1" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter1Average" />
      </div>
      <div class="inputBox">
        <span class="label">投射角度2：</span>
        <van-field class="input" v-model="diameter1.angle2" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter1Average" />
      </div>
      <div class="inputBox">
        <span class="label">投射角度3：</span>
        <van-field class="input" v-model="diameter1.angle3" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter1Average" />
      </div>
      <div class="inputBox">
        <span class="label">平均直径：</span>
        <span>{{ Avg1 }}</span>
      </div>
    </div>

    

    <div class="box">
      <div class="box_title">
        <img src="@/assets/images/choydarIcon1.png" alt="" />
        <span>近端血管直径(mm)</span>
      </div>
      <div class="inputBox">
        <span class="label"><span class="required">*</span>投射角度1：</span>
        <van-field class="input" v-model="diameter2.angle1" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter2Average" />
      </div>
      <div class="inputBox">
        <span class="label">投射角度2：</span>
        <van-field class="input" v-model="diameter2.angle2" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter2Average" />
      </div>
      <div class="inputBox">
        <span class="label">投射角度3：</span>
        <van-field class="input" v-model="diameter2.angle3" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter2Average" />
      </div>
      <div class="inputBox">
        <span class="label">平均直径：</span>
        <span>{{ Avg2 }}</span>
      </div>
    </div>

    <div class="box notRequiredBox">
      <div class="box_title">
        <!-- <img src="@/assets/images/choydarIcon1.png" alt="" /> -->
        <span>瘤颈口血管直径(mm)</span>
      </div>
      <div class="inputBox">
        <span class="label">投射角度1：</span>
        <van-field class="input" v-model="diameter3.angle1" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter3Average" />
      </div>
      <div class="inputBox">
        <span class="label">投射角度2：</span>
        <van-field class="input" v-model="diameter3.angle2" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter3Average" />
      </div>
      <div class="inputBox">
        <span class="label">投射角度3：</span>
        <van-field class="input" v-model="diameter3.angle3" type="number" placeholder="(范围:1.00 ~ 6.00)" @input="diameter3Average" />
      </div>
      <div class="inputBox">
        <span class="label">平均直径：</span>
        <span>{{ Avg3 }}</span>
      </div>
    </div>

    <div class="box1">
      <div class="inputBox">
        <span class="label">血管平均直径Avg：</span>
        <span>{{ AvgX }}</span>
      </div>
      <div class="inputBox">
        <span class="label"><span class="required">*</span>瘤颈口长度(mm)：</span>
        <van-field class="input" v-model="L2" type="number" placeholder="(范围:1.00 ~ 6.00)" />
      </div>
      <div class="inputBox">
        <span class="label"><span class="required">*</span>拟覆盖血管长度(mm)：</span>
        <van-field class="input" v-model="L1" type="number" placeholder="(范围:10.00 ~ 30.00)" />
      </div>
      <div class="inputBox">
        <span class="label">解剖部位：</span>
        <van-field class="input" v-model="AnatomicalSite" placeholder="请输入解剖部位" />
      </div>
      <div class="question">
        <span class="label"><span class="required">*</span>Q1：术者是否已有10台以上强易达使用经验？</span>
        <van-radio-group class="radioBox" v-model="radio1" direction="horizontal">
          <van-radio :name="true">
            是
            <template #icon="props">
              <img class="radio-icon" :src="props.checked ? require('@/assets/images/radio_checked.png') : require('@/assets/images/radio_nochecked.png')" />
            </template>
          </van-radio>
          <van-radio :name="false">
            否
            <template #icon="props">
              <img class="radio-icon" :src="props.checked ? require('@/assets/images/radio_checked.png') : require('@/assets/images/radio_nochecked.png')" />
            </template>
          </van-radio>
        </van-radio-group>
      </div>
      <div class="question">
        <span class="label"><span class="required">*</span>Q2：拟覆盖强易达密网支架的血管是否平直？</span>
        <van-radio-group class="radioBox" v-model="radio2" direction="horizontal">
          <van-radio :name="true">
            是
            <template #icon="props">
              <img class="radio-icon" :src="props.checked ? require('@/assets/images/radio_checked.png') : require('@/assets/images/radio_nochecked.png')" />
            </template>
          </van-radio>
          <van-radio :name="false">
            否
            <template #icon="props">
              <img class="radio-icon" :src="props.checked ? require('@/assets/images/radio_checked.png') : require('@/assets/images/radio_nochecked.png')" />
            </template>
          </van-radio>
        </van-radio-group>
      </div>
      <div class="btnBox">
        <div class="btn" @click="submit">计算支架类型</div>
        <div class="btn" @click="$router.push('/choydarTool')">型号一览表</div>
      </div>
      <div class="resultBox" v-if="IsComputed">
        <div class="resultTitle">
          <img src="@/assets/images/choydarIcon3.png" alt="" />
          <span>推荐支架型号</span>
          <img src="@/assets/images/choydarIcon2.png" alt="" />
        </div>
        <template v-if="result.length > 0">
          <div class="resultItem" v-for="(item, index) in result" :key="index">
            <span>推荐型号{{ index + 1 }}：{{ item }}</span>
            <span class="select" @click="selectModel(item)">选中</span>
          </div>
        </template>
        <div class="notResult" v-else>计算结果超出现有可选型号，请按需要调整术式</div>
      </div>
      <div class="resultBox" v-if="IsComputed">
        <div class="resultTitle">
          <img src="@/assets/images/choydarIcon3.png" alt="" />
          <span>实际使用型号</span>
          <img src="@/assets/images/choydarIcon2.png" alt="" />
        </div>
        <div class="inputBox">
          <span class="label">实际使用型号：</span>
          <van-field class="input" v-model="ActualUse" />
        </div>
      </div>
      <div class="submit" v-if="IsComputed" @click="submitActualUse">提交</div>
      <div class="statement">
        <p>声明：本工具仅供医疗专业人士使用，计算结果仅供医疗专业人士参考，最终以医疗专业人士的临床决策为准。</p><br>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import utils from "../../common/utils/utils";
export default {
  name: 'ChoydarCalculation',
  data() {
    return {
      id: 0,
      diameter1: {
        angle1: '',
        angle2: '',
        angle3: ''
      },
      Avg1: '',
      diameter2: {
        angle1: '',
        angle2: '',
        angle3: ''
      },
      Avg2: '',
      diameter3: {
        angle1: '',
        angle2: '',
        angle3: ''
      },
      Avg3: '',
      L1: '',
      L2: '',
      AnatomicalSite: '',
      radio1: true,
      radio2: true,
      IsComputed: false,
      result: [],
      ActualUse: ''
    }
  },
  computed: {
    AvgX() {
      let Avgs = [this.Avg1, this.Avg2, this.Avg3];
      const validAvgs = Avgs.filter(avg => avg != '' && avg != null && !isNaN(avg));
      if(validAvgs.length > 0) {
        const sum = validAvgs.reduce((acc, curr) => acc + curr, 0);
        return this.truncateToTwoDecimals(sum / validAvgs.length);
      } else {
        return 0;
      }
    }
  },
  created() {
    this.initShare();
  },
  methods: {
    inputBlur(title, val, required) {
      if(required && !val) {
        this.$toast(`${title}不能为空！`);
      } else {
        if(val && (val < 1 || val > 6)) {
          this.$toast(`${title}的值已超出范围！`);
        }
      }
    },
    diameter1Average() {
      let arr = Object.values(this.diameter1).filter(value => value.trim() !== '');
      if(arr.length > 0) {
        let sum = arr.reduce((acc, current) => Number(acc) + Number(current), 0);
        this.Avg1 = this.truncateToTwoDecimals(sum / arr.length);
      } else {
        this.Avg1 = '';
      }
    },
    diameter2Average() {
      let arr = Object.values(this.diameter2).filter(value => value.trim() !== '');
      if(arr.length > 0) {
        let sum = arr.reduce((acc, current) => Number(acc) + Number(current), 0);
        this.Avg2 = this.truncateToTwoDecimals(sum / arr.length);;
      } else {
        this.Avg2 = '';
      }
    },
    diameter3Average() {
      let arr = Object.values(this.diameter3).filter(value => value.trim() !== '');
      if(arr.length > 0) {
        let sum = arr.reduce((acc, current) => Number(acc) + Number(current), 0);
        this.Avg3 = this.truncateToTwoDecimals(sum / arr.length);;
      } else {
        this.Avg3 = '';
      }
    },
    submit() {
      if (!this.diameter1.angle1) {
        this.$toast('请输入远端血管直径投射角度1！');
        return false;
      }

      if (!this.diameter2.angle1) {
        this.$toast('请输入近端血管直径投射角度1！');
        return false;
      }

      if (!this.L2) {
        this.$toast('请输入瘤颈口长度！');
        return false;
      }

      if (!this.L1) {
        this.$toast('请输入拟覆盖血管长度！');
        return false;
      }

      const toast = this.$toast.loading({
        message: '计算中...',
        forbidClick: true,
      });

      let MaxX = Math.max(this.Avg1, this.Avg2, this.Avg3);
      this.$axios.post('/Api/api/Web/GetCedFDRate/GetSpecificationList', {
        MaxX: MaxX * 100,
        L1: Number(this.L1),
        L2: Number(this.L2),
        Type: this.radio1 && this.radio2 ? 1 : 2
      }).then(res => {
        this.result = res.Data;
        this.IsComputed = true;
        this.submitData();
        toast.clear();
        this.$nextTick(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        })
      })
    },
    submitData() {
      let MaxX = Math.max(this.Avg1, this.Avg2, this.Avg3);
      this.$axios.post('/Api/api/Web/GetCedFDRate/AddSelSpecification', {
        FarParam1: this.diameter1.angle1,
        FarParam2: this.diameter1.angle2,
        FarParam3: this.diameter1.angle3,
        FarAvg: this.Avg1,
        NearParam1: this.diameter2.angle1,
        NearParam2: this.diameter2.angle2,
        NearParam3: this.diameter2.angle3,
        NearAvg: this.Avg2,
        NeckParam1: this.diameter3.angle1,
        NeckParam2: this.diameter3.angle2,
        NeckParam3: this.diameter3.angle3,
        NeckAvg: this.Avg3,
        ThreeAvg: this.AvgX,
        MaxXAvg: MaxX,
        Len1: this.L1,
        Len2: this.L2,
        DissectedParts: this.AnatomicalSite,
        MoreTenExperienceFlag: this.radio1,
        IsFlatFlag: this.radio2,
        SpecificationName: this.result.join(',')
      }).then(res => {
        this.id = res.Data;
      })
    },
    selectModel(val) {
      this.ActualUse = val;
    },
    submitActualUse() {
      if(this.id == 0) {
        this.$toast('请先计算支架类型！');
      } else if(this.ActualUse == '') {
        this.$toast('请输入实际使用型号！');
      } else {
        this.$axios.post('/Api/api/Web/GetCedFDRate/UpdateSelSpecification', {
          id: this.id,
          SelSpecificationName: this.ActualUse
        }).then(res => {
          this.$toast.success('提交成功');
        })
      }
    },
    truncateToTwoDecimals(num) {
      const numStr = num.toString();
      const decimalIndex = numStr.indexOf('.');
      if (decimalIndex === -1) {
        return num;
      }
      return parseFloat(numStr.substring(0, decimalIndex + 3));
    },
    initShare() {
      let that = this;
      const entryLink = utils.getEntryLink();
      that.$axios
        .get("/Api/Api/web/ShareLog/wxHelp?backUrl=" + entryLink)
        .then((res) => {
          wx.config({
            debug: false,
            appId: 'wxf77916b15f3905df',
            timestamp: res.Data.TimesTamp,
            nonceStr: res.Data.NonceStr,
            signature: res.Data.She1Str,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
          });
          wx.checkJsApi({
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "updateAppMessageShareData", // 分享到朋友圈接口
              "updateTimelineShareData", //  分享到朋友接口
            ],
            success: async function (res) {
              wx.ready(() => {
                wx.updateAppMessageShareData({
                  title: '强易达选型工具',
                  link: window.location.href,
                  desc: '',
                  imgUrl: "https://jpubliccnv.jjmc.cn/api/UploadImg/0340fb7a72664b15ab40778eee55889a.jpg",
                  success: function (res) {},
                });
                wx.updateTimelineShareData({
                  title: '强易达选型工具',
                  link: window.location.href,
                  desc: '',
                  imgUrl: "https://jpubliccnv.jjmc.cn/api/UploadImg/0340fb7a72664b15ab40778eee55889a.jpg",
                  success: function (res) {},
                });
              });
            },
          });
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 10px 10px 60px;
  color: #333333;
  .box {
    padding: 10px 15px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px 0px;
    border-radius: 6px;
    margin-bottom: 10px;
    .box_title {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      img {
        display: block;
        width: 12px;
        margin-right: 5px;
      }
    }
    .inputBox {
      display: flex;
      font-size: 14px;
      align-items: center;
      margin: 10px 0;
      .label {
        width: 90px;
        text-align: right;
        .required {
          color: red;
        }
      }
      .input {
        width: 0;
        flex: 1;
        padding: 0 5px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        /deep/ input {
          height: 32px;
        }
      }
    }
  }
  .notRequiredBox {
    .box_title {
      opacity: 0.7;
    }
    .label {
      opacity: 0.7;
    }
  }
  .box1 {
    padding: 0px 15px;
    .inputBox {
      display: flex;
      font-size: 14px;
      align-items: center;
      margin: 10px 0;
      .label {
        padding-left: 6px;
        .required {
          color: red;
        }
      }
      .input {
        flex: 1;
        padding: 0 5px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        /deep/ input {
          height: 32px;
        }
      }
    }
    .question {
      padding-left: 7px;
      .label {
        .required {
          color: red;
        }
      }
    }
    .radioBox {
      padding: 10px 0 10px 35px;
      .radio-icon {
        width: 15px;
      }
    }
  }
  .btnBox {
    display: flex;
    justify-content: space-between;
    .btn {
      width: 40%;
      height: 30px;
      line-height: 30px;
      border-radius: 0 18px 0 18px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      background-color: #EB1700;
      margin: 10px auto;
    }
  }
  .submit {
    width: 40%;
    height: 30px;
    line-height: 30px;
    border-radius: 30px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    background-color: #EB1700;
    margin: 10px auto;
  }
  .resultBox {
    padding: 10px 15px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px 0px;
    border-radius: 6px;
    margin: 10px 0 20px;
    .resultTitle {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 30px;
      }
      span {
        margin: 0 10px;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .resultItem {
      display: flex;
      align-content: center;
      font-size: 14px;
      margin: 15px 0;
      .select {
        font-size: 12px;
        display: inline-block;
        padding: 2px 6px;
        color: #FFFFFF;
        background-color: #EB1700;
        border-radius: 4px;
        margin-left: 5px;
      }
    }
    .notResult {
      font-size: 13px;
      text-align: center;
      margin: 10px 0;
    }
  }
  .statement {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    font-size: 11px;
    color: #FFFFFF;
    padding: 6px 10px;
    box-sizing: border-box;
    .p {
      text-align: right;
    }
  }
}
</style>